import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { SheetRowNavigation } from '@/hooks/useSheetRowNavigation'

export function SheetRowNavButtons({
  navigation,
  noun,
}: {
  navigation: Pick<
    SheetRowNavigation<unknown>,
    'prevId' | 'nextId' | 'onPrev' | 'onNext'
  >
  noun: string
}) {
  return (
    <>
      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7"
        disabled={!navigation.prevId}
        onClick={navigation.onPrev}
        aria-label={`Previous ${noun}`}
        title={`Previous ${noun} (↑)`}>
        <ChevronUp className="h-5 w-5" aria-hidden />
      </Button>
      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7"
        disabled={!navigation.nextId}
        onClick={navigation.onNext}
        aria-label={`Next ${noun}`}
        title={`Next ${noun} (↓)`}>
        <ChevronDown className="h-5 w-5" aria-hidden />
      </Button>
    </>
  )
}
